export function transformBrand(codeVendeur: string): string {
  switch (codeVendeur.toUpperCase()) {
    case 'VYV':
      return 'VY';
    case 'HM':
      return 'HM';
    case 'MGEN':
      return 'MG';
    case 'MNT':
      return 'MT';
    default:
      return codeVendeur.toUpperCase();
  }
}

export const HmBrand = 'HM';
export const MgenBrand = 'MGEN';
export const MntBrand = 'MNT';


export function isPartner(environment: any): boolean {
  return (environment.brand === HmBrand || environment.brand === MgenBrand || environment.brand === MntBrand);
}
